import { Stack, Typography } from "@mui/material";
import React from "react";
import getAlphabetForIndex from "../../../utility/getAlphabetForIndex";
import { FontFamily } from "../../../enums";

interface QuestionOptionPreviewProps {
  optionText: string;
  optionIndex: number;
  language: "english" | "hindi";
  isCorrect?: boolean;
}

const QuestionOptionPreview: React.FC<QuestionOptionPreviewProps> = ({
  optionText,
  optionIndex,
  isCorrect = false,
}) => {
  return (
    <Stack
      direction={"row"}
      gap={"10px"}
      p={"12px"}
      border={isCorrect ? "2px solid #1CAA6E" : "1px solid #C8C8C8"}
      borderRadius={"5px"}
      bgcolor={isCorrect ? "#E4F5EE" : "#FFFFFF"}
    >
      <Typography
        fontStyle={"normal"}
        fontWeight={400}
        fontSize={"16px"}
        lineHeight={"125%"}
        textAlign={"left"}
        fontFamily={FontFamily.gilroy}
        color={"#121212"}
      >
        <span>{`${getAlphabetForIndex(optionIndex)}. `}</span>
      </Typography>
      <Typography
        fontStyle={"normal"}
        fontWeight={400}
        fontSize={"16px"}
        lineHeight={"125%"}
        textAlign={"left"}
        fontFamily={FontFamily.gilroy}
        color={"#121212"}
      >
        <span
          style={{ wordBreak: "break-word", whiteSpace: "normal" }}
          dangerouslySetInnerHTML={{
            __html: optionText || "",
          }}
        />
      </Typography>
    </Stack>
  );
};

export default QuestionOptionPreview;
